import { Stack } from '@mui/material';
import { FlowGetExternalDocumentPacketOption } from 'flow-schema';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function ExternalDocumentPacketsFormFields() {
  const { value: externalDocumentPacketOption } =
    useSelectedNodeField<FlowGetExternalDocumentPacketOption>(
      'config.getExternalDocumentPacketOption'
    );
  return (
    <>
      <Stack gap={2}>
        <BlockRadioGroupField
          fieldName="config.getExternalDocumentPacketOption"
          label="Options"
          row
          defaultValue={FlowGetExternalDocumentPacketOption.GetOneById}
          options={[
            { label: 'Get one by ID', value: FlowGetExternalDocumentPacketOption.GetOneById },
            {
              label: 'Find by file name',
              value: FlowGetExternalDocumentPacketOption.FindByFileName,
            },
          ]}
        />
        {externalDocumentPacketOption === FlowGetExternalDocumentPacketOption.FindByFileName ? (
          <BlockValueTemplateField
            fieldName="config.fileName"
            label="File Name"
            required
            helperText="File name to match (case-insensitive, extensions ignored). e.g. `TestDocument` or `{{start.data.fileName}}`"
            placeholder="e.g. {{start.data.fileName}}"
          />
        ) : (
          <BlockValueTemplateField
            fieldName="config.externalDocumentPacketId"
            label="External Document Packet ID"
            required
            helperText="Enter the reference to the EDP ID. e.g. `{{start.data.externalDocumentPacketId}}`"
            placeholder="e.g. {{start.data.externalDocumentPacketId}}"
          />
        )}
      </Stack>
    </>
  );
}
